import RulerToolEnum from './RulerToolConstants';

export const setRulerActive = active => (
  (dispatch) => {
    dispatch({ type: RulerToolEnum.RULER_IS_ACTIVE, active });
  }
);

export const setRulerColor = color => (
  (dispatch) => {
    dispatch({ type: RulerToolEnum.SET_RULER_COLOR, color });
  }
);

export function toggleRulerTool() {
  return (dispatch) => {
    dispatch({ type: RulerToolEnum.TOGGLE_RULER_TOOL });
  };
}



// WEBPACK FOOTER //
// ./src-react/RulerTool/RulerToolActions.jsx